module.exports = __webpack_public_path__ + "img/1.aaee9981.jpg";